import { useEffect, useState } from "react"
import { Bell, Settings2 } from "lucide-react"
import { useWorkspaceStore } from "../stores/workspace.store"

function useClock() {
  const [time, setTime] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(id)
  }, [])
  return time
}

const MONTHS_PT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"]

interface PianoTopbarProps {
  pageName?: string
  pageCategory?: string
}

export function PianoTopbar({ pageName }: PianoTopbarProps) {
  const { currentWorkspace } = useWorkspaceStore()
  const now = useClock()

  const hh = String(now.getHours()).padStart(2, "0")
  const mm = String(now.getMinutes()).padStart(2, "0")
  const ss = String(now.getSeconds()).padStart(2, "0")
  const dd = String(now.getDate()).padStart(2, "0")
  const mon = MONTHS_PT[now.getMonth()]
  const yyyy = now.getFullYear()

  const label = pageName || "Início"
  const wsName = currentWorkspace?.name || ""

  return (
    <div className="piano-topbar">
      {/* Row 1 — strip fino: breadcrumb + status + clock */}
      <div className="piano-topbar__strip">
        <div className="piano-topbar__strip-left">
          <span className="piano-topbar__category">VISÃO GERAL</span>
          <span className="piano-topbar__strip-sep">·</span>
          <span className="piano-topbar__page">{wsName}</span>
        </div>
        <div className="piano-topbar__strip-right">
          <span className="piano-topbar__status">
            <span className="piano-topbar__status-dot" />
            Sistema operacional
          </span>
          <button className="piano-topbar__icon-btn" title="Notificações">
            <Bell className="w-3.5 h-3.5" />
          </button>
          <button className="piano-topbar__icon-btn" title="Configurações">
            <Settings2 className="w-3.5 h-3.5" />
          </button>
          <div className="piano-topbar__clock">
            <span className="piano-topbar__clock-time">{hh}:{mm}:{ss}</span>
            <span className="piano-topbar__clock-date">{dd}/{mon}/{yyyy}</span>
          </div>
        </div>
      </div>

      {/* Row 2 — título grande */}
      <div className="piano-topbar__title-row">
        <div className="piano-topbar__title">{label}</div>
        <div className="piano-topbar__subtitle">{mon} {yyyy} · {wsName}</div>
      </div>
    </div>
  )
}
